 /*eslint-disable import/no-anonymous-default-export*/
export default {
    UPDATE_VENDOR: () => `/vendor/auth/updateProfile`,
    UPDATE_DRIVER: (id) => `/vendor/drivers/updateMyDriver/${id}`,
    GET_VENDOR: () => `/vendor/auth/profile`,
    DELETE_ACCOUNT: () => `/vendor/auth/deleteAccount`,
    SET_ONLINE_STATUS: () => `/vendor/auth/setOnlineStatus`,
    WHATSAPP_CONNECT: () => `/vendor/auth/whatsappConnect`,
    GET_DRIVER: () => `/vendor/drivers/myDrivers`,
    ADD_DRIVER: () => `/vendor/drivers/registerDriver`,
    ADD_VENDOR_SUBSCRIPTION: () => `/vendor/vendorSubscriptions/add`,
    GET_ALL_VENDOR_SUBSCRIPTIONS: () => `/vendor/vendorSubscriptions/getAll`,
    GET_VENDOR_SUBSCRIPTION_BY_ID: (id) => `/vendor/vendorSubscriptions/getById/${id}`,
    UPDATE_VENDOR_SUBSCRIPTION: (id) => `/vendor/vendorSubscriptions/update/${id}`,
    DELETE_VENDOR_SUBSCRIPTION: (id) => `/vendor/vendorSubscriptions/delete/${id}`,
    ACTIVATE_VENDOR_SUBSCRIPTION: (id) => `/vendor/vendorSubscriptions/activate/${id}`,
    GET_SYSTEM_CONFIG_BY_KEY: (key) => `/vendor/systemConfigs/getByKey/${key}`,
    GET_ONE_WAY_ELIGIBILITY: () => `/vendor/oneWayAvailabilities/eligibility`,
    GET_ONE_WAY_STATS: () => `/vendor/oneWayAvailabilities/stats`,
    CREATE_ONE_WAY_AVAILABILITY: () => `/vendor/oneWayAvailabilities/create`,
    GET_ALL_ONE_WAY_AVAILABILITIES: () => `/vendor/oneWayAvailabilities/getAll`,
    GET_ONE_WAY_AVAILABILITY_BY_ID: (id) => `/vendor/oneWayAvailabilities/getById/${id}`,
    UPDATE_ONE_WAY_AVAILABILITY: (id) => `/vendor/oneWayAvailabilities/update/${id}`,
    DELETE_ONE_WAY_AVAILABILITY: (id) => `/vendor/oneWayAvailabilities/delete/${id}`,
    TOGGLE_ONE_WAY_AVAILABILITY_ACTIVATION: (id) => `/vendor/oneWayAvailabilities/toggleActivation/${id}`,
    GET_MY_ONE_WAY_BOOKINGS: () => `/vendor/oneWayAvailabilityInquiries/myConfirmed`,
    GET_INQUIRIES_BY_AVAILABILITY_ID: (id) => `/vendor/oneWayAvailabilityInquiries/getByAvailabilityId/${id}`,
  };
  